import { settings } from "@/settings";
import { api } from "@/auth/api";

const baseUrl = `${settings.api_url}/odm-offer/api/1/odm-offer`

export async function getProposalStatus(statusId: string) {
    return api().get(`${baseUrl}/proposalstatus/${statusId}/`)
}
